import React, { useState, useEffect } from "react";
import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Button from "@components/Button";
import SectionHeader from "../SectionHeader";
import BrandLogo from "../BrandLogo";
import { useNavigate } from "react-router";
import "./style.scss";
import { parseCMSBold } from "@app/Helpers";
import DOMPurify from "dompurify";

export default NiceModal.create(() => {
  const modal = useModal();
  const navigate = useNavigate();

  const args = modal.args ?? {};
  const customModal = args.customModal;

  const isUltra = args.ident?.includes("_ultrainsider") || args.isUltra;
  const isCustom = Boolean(customModal);

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => modal.hide()}
      onAfterClose={() => modal.remove()}
      innerClass={`redeem-award-modal ${isUltra ? "ultrainsider" : ""}`}
      disableClose={true}
    >
      <>
        <SectionHeader>
          {isCustom ? (
            <span
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(parseCMSBold(args.title ?? "")),
              }}
            />
          ) : (
            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(`Der Gutschein <strong>gehört jetzt dir!</strong>`),
              }}
            />
          )}
        </SectionHeader>

        <div className="desktop-wrapper">
          <div className="img-wrapper">
            <img
              src={isCustom ? customModal?.file?.url : args.bg}
              alt={args.imgDesc ?? ""}
            />
            <BrandLogo brands={args.brands} />
          </div>

          <div className="copy">
            {isCustom ? (
              <p
                className="award-name"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(parseCMSBold(customModal?.custom ?? "")),
                }}
              />
            ) : (
              <>
                <p
                  className="award-name"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(parseCMSBold(args.awardName ?? "")),
                  }}
                />

                {args.awardDesc && (
                  <p
                    className="award-desc"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(parseCMSBold(args.awardDesc ?? "")),
                    }}
                  />
                )}

                {args.logos && (
                  <>
                    <p className="logos-header">
                      <strong>Zur Verwendung auf:</strong>
                    </p>

                    <div
                      className={`logos ${args.isMonoColor ? "monoColor" : ""}`}
                    >
                      {args.logos.map((e, index) => (
                        <img
                          src={e?.file?.url}
                          alt={e?.alt ?? ""}
                          key={index}
                        />
                      ))}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>

        <div className="buttons-wrapper">
          {isCustom ? (
            <Button
              btnClass={isUltra ? "ultra-insider outline" : "outline yellow"}
              action={() => {
                navigate(customModal?.metadata?.buttonURL ?? "/coupons");
                modal.hide();
              }}
            >
              {customModal?.metadata?.buttonCopy ?? "Zurück"}
            </Button>
          ) : (
            <Button
              btnClass={isUltra ? "ultra-insider outline" : "outline yellow"}
              action={() => {
                navigate("/coupons");
                modal.hide();
              }}
            >
              Zurück zum Gutscheinkatalog
            </Button>
          )}

          <Button
            action={() => {
              navigate(`/coupons/received/${args.awardUUID}`);
              modal.hide();
            }}
            btnClass={isUltra ? "ultra-insider" : "yellow"}
          >
            Gutschein ansehen
          </Button>
        </div>
      </>
    </Modal>
  );
});
